import { Component, Input } from '@angular/core';
import { ApiservicesService } from '../../../../Services/Apis/apiservices.service';
import { ActivatedRoute, Router } from '@angular/router';

// Angular Material Standalone Imports
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule, NgClass } from '@angular/common';
import { TranslateDirective } from '../../../../components/Utilites/Directives/translate.directive';

@Component({
  selector: 'app-applicantslist',
  standalone: true,
  imports: [
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    NgClass,
    CommonModule,
    TranslateDirective
  ],
  templateUrl: './applicantslist.component.html',
  styleUrls: ['./applicantslist.component.scss'], // ✅ fixed plural
})
export class ApplicantslistComponent {
  @Input() JobApplicantsId!: string;
  @Input() websiteId!: string;
  @Input() pageId!: string;

  JobApplicantsList: any[] = [];

  displayedColumns: string[] = [
    'Applican_Name',
    'Mobile_Number',
    'email',
    'resume',
    'status',
    'actions',
  ];

  constructor(
    private apiServices: ApiservicesService,
    private route: ActivatedRoute,
    private _router: Router
  ) {}

  ngOnInit(): void {
    this.JobApplicantsId = this.route.snapshot?.paramMap.get('id') || '';
    this.websiteId = this.route.snapshot?.paramMap.get('websiteId') || '';
    this.pageId = this.route.snapshot?.paramMap.get('pageId') || '';
    this.getJobApplicants();
  }

  getJobApplicants(): void {
    this.apiServices.getJobApplicantsList(this.JobApplicantsId).subscribe({
      next: (res: any) => {
        if (res?.data) {
          // ✅ Ensure it's always an array
          this.JobApplicantsList = Array.isArray(res.data)
            ? res.data
            : [res.data];
        } else {
          console.error('Error: No data received from API');
          this.JobApplicantsList = [];
        }
      },
      error: (err) => {
        console.error('Error fetching careers:', err);
        this.JobApplicantsList = [];
      },
    });
  }

  getResumeUrl(path: any): string {
    return `${this.apiServices.environmentPath} /${path}`;
  }

  viewApplicant(applicant: any): void {
    console.log('Viewing applicant:', applicant);
  }

  editApplicant(applicant: any): void {
    console.log('Editing applicant:', applicant);
  }
  goBack(): void {
    this._router.navigate([
      `websites/WebcomponentList/careers/careers`],  {
        queryParams: { websiteId:this.websiteId, pageId: this.pageId}
      });
  }
}
